import { ReactComponent as Crown } from '@portals/icons/bulk/crown.svg';
import { ReactComponent as Flag } from '@portals/icons/bulk/flag.svg';
import { ReactComponent as Flash } from '@portals/icons/bulk/flash.svg';
import { ReactComponent as MagicStar } from '@portals/icons/bulk/magic-star.svg';
import { PartnerPricingPlanName } from '@portals/types';

export function getPricingPlanDisplayName(
  pricingPlanName: PartnerPricingPlanName | undefined
) {
  if (!pricingPlanName) return 'Unknown';

  switch (pricingPlanName) {
    case 'msp':
      return 'Free';
    case 'free':
      return 'Free';
    case 'standard':
      return 'Standard';
    case 'premium':
      return 'Premium';
    case 'enterprise':
      return 'Enterprise';
  }
}

export function getPricingPlanIcon(
  pricingPlanName: PartnerPricingPlanName | undefined
) {
  if (!pricingPlanName) return;

  switch (pricingPlanName) {
    case 'free':
      return Flag;
    case 'standard':
      return MagicStar;
    case 'premium':
      return Crown;
    case 'enterprise':
      return Flash;
  }
}
